import { render, staticRenderFns } from "./ItemComparison.vue?vue&type=template&id=4d0d089f&"
import script from "./ItemComparison.vue?vue&type=script&lang=js&"
export * from "./ItemComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports